import { render, staticRenderFns } from "./AppWebSettings.vue?vue&type=template&id=2520d2bf&"
import script from "./AppWebSettings.vue?vue&type=script&lang=js&"
export * from "./AppWebSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports